var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 772 772",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 358 614 C 344 608 327 605 312 604 250 598 188 590 128 582 104 578 81 575 58 572 58 572 31 568 30 556 29 546 35 533 42 526 L 73 492 C 131 428 191 361 251 298 268 281 267 266 261 244 L 260 239 264 237 C 265 236 267 235 280 232 283 231 286 230 286 230 L 293 228 295 234 C 297 244 299 250 302 253 303 253 308 252 310 251 L 314 251 C 352 243 390 234 428 226 504 210 579 194 655 178 664 176 667 172 668 170 L 670 167 715 154 744 262 698 274 C 697 275 693 278 692 280 L 669 305 C 580 405 490 504 402 604 393 614 385 619 376 619 371 619 364 617 358 614 Z M 68 543 L 348 572 279 314 68 543 Z M 318 287 C 315 288 313 289 312 290 312 291 311 293 313 298 317 312 320 326 324 340 L 384 556 401 537 C 418 517 435 499 451 480 522 398 594 316 665 233 666 232 667 231 668 230 672 226 675 222 676 217 L 318 287 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.386853da42bcd808f2c627c7cd4cf257.svg";
export { ForwardRef as ReactComponent };